export const LOOKAHEAD = {
  // Dialog
  DIALOG: 'gantt-timeframe-dialog',
  DIALOG_TITLE: 'gantt-timeframe-dialog-title',
  DIALOG_CLOSE: 'gantt-timeframe-dialog-close',

  // Rolling popover (new rolling lookaheads)
  ROLLING_POPOVER: 'lookahead-rolling-popover',
  ROLLING_POPOVER_TITLE: 'lookahead-rolling-popover-title',

  // Segmented control
  SEGMENTED_CONTROL: 'lookahead-segmented-control',
  SEGMENTED_ROLLING_WINDOW: 'lookahead-segmented-rolling-window',
  SEGMENTED_FIXED_RANGE: 'lookahead-segmented-fixed-range',

  // Date pickers
  FROM_DATE_PICKER: 'gantt-timeframe-from-date-picker',
  TO_DATE_PICKER: 'gantt-timeframe-to-date-picker',
  DATE_PICKER_CALENDAR: 'gantt-timeframe-date-picker-calendar',

  // Quick dates
  QUICK_DATES_CONTAINER: 'gantt-timeframe-quick-dates-container',
  QUICK_DATE_ITEM: 'gantt-timeframe-quick-date-item',

  // Buttons
  CLEAR_SELECTION_BUTTON: 'gantt-timeframe-clear-selection-button',
  CLEAR_LOOKAHEAD_BUTTON: 'gantt-timeframe-clear-lookahead-button',
  CANCEL_BUTTON: 'gantt-timeframe-cancel-button',
  SET_BUTTON: 'gantt-timeframe-set-button',
  LOOKAHEAD_BUTTON: 'gantt-timeframe-button',
  LOOKAHEAD_BUTTON_ICON: 'gantt-timeframe-button-icon',
  LOOKAHEAD_BUTTON_TEXT: 'gantt-timeframe-button-text',

  // Rolling window content
  ROLLING_START_DATE_TYPE: 'lookahead-rolling-start-date-type',
  ROLLING_DAY_OF_WEEK: 'lookahead-rolling-day-of-week',
  ROLLING_DURATION_INPUT: 'lookahead-rolling-duration-input',
  ROLLING_LEARN_MORE_CLOSE: 'lookahead-rolling-learn-more-close'
} as const;
